<template>
	<div style="height: 600px; overflow-y: auto; overflow-x: hidden">
		<div class="yl-flex flex_between">
			<Form :label-width="80">
				<FormItem label="时间">
					<RadioGroup v-model="timePeriod" >
						<Radio label="0" border><span>不限</span></Radio>
						<Radio label="1" border><span>今日</span></Radio>
						<Radio label="2" border><span>昨天</span></Radio>
						<Radio label="3" border><span>本周</span></Radio>
						<Radio label="4" border><span>上周</span></Radio>
						<Radio label="5" border><span>本月</span></Radio>
						<Radio label="6" border><span>上月</span></Radio>
						<Radio label="7" border><span>自定义</span></Radio>
						<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" 
							type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</RadioGroup>
				</FormItem>
				<FormItem label="条件">
					<el-select v-model="city" style="width: 100px;margin-left: 10px;width: 150px;"  placeholder="请选择城市">
						<el-option v-for="item in cityList" :value="item.city" :key="item.city">
							{{ item.city}}
						</el-option>
					</el-select>
					<el-select v-model="src" style="width: 100px;margin-left: 10px;width: 150px;" :reserve-keyword="true" filterable multiple placeholder="请选择媒体代码">
						<el-option  v-for="item in srcList" :key="item.src" :label="item.src"
							:value="item.src">
						</el-option>
					</el-select>
					<el-select v-model="account" style="width: 100px;margin-left: 10px;width: 150px;" :reserve-keyword="true" filterable multiple placeholder="请选择账户">
						<el-option v-for="item in accountList" :value="item.account_id" :label="item.account_name" :key="item.account_id">
							{{ item.account_name}}
						</el-option>
					</el-select>
					<el-select v-model="operationUser" style="width: 100px;margin-left: 10px;width: 150px;" :reserve-keyword="true" filterable multiple placeholder="请选择账户">
						<el-option v-for="item in operationList" :value="item.uid" :label="item.username" :key="item.uid">
							{{ item.username}}
						</el-option>
					</el-select>
					<el-Input placeholder="计划id" v-model="searchAdid"
						style="width: 100px;margin-left: 10px;width: 150px;"></el-Input>
					<el-Button type="primary" @click="mySearch" style="margin-left: 10px;">搜索</el-Button>
					<el-Button @click="initSearch" style="margin-left: 10px;">重置</el-Button>
				</FormItem>
			</Form>
		</div>
		<Table border :columns="columns" :data="datas">
			<template slot-scope="{ row,index }" slot="twoplus">
				<div v-if="row.our_num !=0">
					<span>{{row.twoplus+row.three+row.four}}/{{(((row.twoplus+row.three+row.four)/row.our_num).toFixed(2))}}</span>
				</div>
				<div v-if="row.our_num ==0">
					<span>{{row.twoplus+row.three+row.four}}/0</span>
				</div>
			</template>
			<template slot-scope="{ row,index }" slot="threePlus">
				<div v-if="row.our_num !=0">
					<span>{{row.twoplus+row.three+row.four}}/{{(((row.three+row.four)/row.our_num).toFixed(2))}}</span>
				</div>
				<div v-if="row.our_num ==0">
					<span>{{row.twoplus+row.three+row.four}}/0</span>
				</div>
			</template>
			<template slot-scope="{ row,index }" slot="threePlusReal">
				<div v-if="row.our_num !=0">
					<span>{{row.three+row.four}}/{{(((row.three+row.four)/row.all_num).toFixed(2))}}</span>
				</div>
				<div v-if="row.our_num ==0">
					<span>{{row.three+row.four}}/0</span>
				</div>
			</template>
			<template slot-scope="{ row,index }" slot="zhuangku_rate">
				<div v-if="row.zhuangku_rate >0.2">
					<span style="color:#ffaa00;cursor: pointer;">{{row.zhuangku_rate}}</span>
				</div>
				<div v-else>
					<span>{{row.zhuangku_rate}}</span>
				</div>
			</template>
		</Table>
		<div class="pager1">
			<Page :total="count" show-total show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				@on-page-size-change="changeSize" :current="page" @on-change="changePage" size="small" show-elevator />
		</div>
	</div>
</template>

<script>
	import {
		getClientList,
	} from "../../../api/advManage.js";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		name: "adidData",
		components: {

		},
		props:['cityList','cidTypeList','srcList','accountList','operationList'],
		data() {
			return {
				columns: [
					{
						"title": "广告id",
						"key": "adid",
						"align": 'center',
					},
					{
						"title": "媒体代码",
						"key": "src",
						"align": 'center',
					},
					{
						"title": "城市",
						"key": "city",
						"align": 'center',
					},
					{
						"title": "时间",
						"key": "time",
						"align": 'center',
					},
				],
				timePeriod: '1',
				timePeriodDate: [],
				city: '',
				src: '',
				adid: '',
				searchAdid: '',
				operationUser:[],
				account: [],
				datas: [],
				count: 0,
				page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100],
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			changeDate(e) {
				//this.getList();
			},
			initSearch() {
				this.page = 1;
				this.pageSize = 20;
				this.city = '';
				this.src = '';
				this.searchAdid = '';
				this.timePeriod = '1';
				this.timePeriodDate = [];
				this.operationUser = [];
				this.account = [];
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.adid = that.adid;
				data.timePeriod = that.timePeriod;
				data.timePeriodDate = that.timePeriodDate;
				data.city = that.city;
				data.src = that.src;
				data.account = that.account;
				data.adid = that.searchAdid;
				data.operationUser = that.operationUser;
				data.page = that.page;
				data.pageSize = that.pageSize;
				let res = await getClientList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
		},
	};
</script>

<style lang="less" scoped>
/deep/ .ivu-table th {
  background: #277dd3;
  color: white;
}
/deep/ .ivu-table .table-blue-row td {
  color: #ff6699;
}
/deep/ .ivu-table .table-yellow-row td {
  color: #aaaa00;
}

/deep/ .ivu-table .table-black-row td {
  color: black;
}
	
</style>
